var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-screen" }, [
    _c("div", { staticClass: "login-hero" }, [
      _c("img", {
        staticClass: "login-hero__mark",
        attrs: {
          src: require("@/assets/images/syscore_logo_mini.svg"),
          alt: "",
        },
      }),
      _c("div", { staticClass: "login-hero__copy" }, [
        _c("img", {
          staticClass: "login-hero__lockup",
          attrs: {
            src: require("@/assets/images/syscore_logo.svg"),
            alt: "Syscore",
          },
        }),
      ]),
    ]),
    _c("div", { staticClass: "login-form-side" }, [
      _c(
        "div",
        { staticClass: "login-form" },
        [
          _vm._t("default"),
          _c("div", { staticClass: "login-form__footer" }, [
            _vm._v("SyscoreHR © " + _vm._s(_vm.current_year) + " · IngeniAR"),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }